import { typeof as _typeof, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { getViewportMediaQueryXlMin, getViewportMediaQueryLgMin, getViewportMediaQueryMdMin, getViewportMediaQuerySmMin } from '../../styles/viewport.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import '../ElevatorAnimation/ElevatorAnimation.styles.js';
import { ElevatorAnimationWrapper } from '../ElevatorAnimation/ElevatorAnimationWrapper.js';
import '../PictureBackground/PictureBackgroundPresentation.js';
import { PictureBackgroundWrapper } from '../PictureBackground/PictureBackgroundWrapper.js';
import { hostClass } from './Picture.styles.js';

var PicturePresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;

  var id = props.id,
      alt = props.alt,
      caption = props.caption,
      src = props.src,
      className = props.className,
      asInline = props.asInline,
      asBackgroundImage = props.asBackgroundImage,
      imgWidth = props.imgWidth,
      imgHeight = props.imgHeight,
      maxWidth = props.maxWidth,
      style = props.style,
      noMargin = props.noMargin,
      imgAttrs = props.imgAttrs,
      yellowElevator = props.yellowElevator,
      horizontalAlignment = props.horizontalAlignment;
  var source = props.source || [_typeof(src) === "object" && src.xl && {
    srcSet: src.xl,
    media: getViewportMediaQueryXlMin()
  }, _typeof(src) === "object" && src.lg && {
    srcSet: src.lg,
    media: getViewportMediaQueryLgMin()
  }, _typeof(src) === "object" && src.md && {
    srcSet: src.md,
    media: getViewportMediaQueryMdMin()
  }, _typeof(src) === "object" && src.sm && {
    srcSet: src.sm,
    media: getViewportMediaQuerySmMin()
  }, _typeof(src) === "object" && src.xs && {
    srcSet: src.xs
  }].filter(function (s) {
    return !!s;
  });
  var imgSrc = props.imgSrc || (_typeof(props.src) === "object" ? props.src.default : props.src);

  if (asBackgroundImage) {
    return /*#__PURE__*/React.createElement(PictureBackgroundWrapper, Object.assign({}, props, {
      source: source,
      imgSrc: imgSrc
    }));
  }

  var Picture = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("picture", {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, "".concat(className), !!className), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__inline"), asInline), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    style: Object.assign(Object.assign({}, style), {
      maxWidth: maxWidth
    })
  }, source.map(function (s, i) {
    return (
      /*#__PURE__*/

      /* eslint-disable-next-line react/no-array-index-key */
      React.createElement("source", Object.assign({
        key: i
      }, s))
    );
  }), /*#__PURE__*/React.createElement("img", Object.assign({}, imgAttrs, {
    src: imgSrc,
    alt: alt,
    className: "".concat(hostClass, "-img"),
    height: imgHeight,
    width: imgWidth,
    style: {
      maxWidth: maxWidth
    }
  }))));

  var CaptionWrapper = function CaptionWrapper(_ref) {
    var horizontalAlign = _ref.horizontalAlignment;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(hostClass, "__caption"),
      style: {
        textAlign: horizontalAlign
      }
    }, caption);
  }; // TODO port legacy browser fallback


  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, hostClass, true), _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject2))
  }, yellowElevator ? /*#__PURE__*/React.createElement(ElevatorAnimationWrapper, {
    active: yellowElevator
  }, Picture) : Picture, caption && /*#__PURE__*/React.createElement(CaptionWrapper, {
    horizontalAlignment: horizontalAlignment
  }));
});

export { PicturePresentation };
